import flagSvg from './en-flag.svg';

export default function EnFlag() {
  return <img src={flagSvg} alt="English " />;
}
